import screenbanner from "./images/banner/1.jpg";
import mobilebanner from "./images/banner/2.jpg";
import Rohit_Goyal from "./images/founder/r.png"
import Shivali_Gupta from "./images/founder/s.png"
import Vishal_Gupta from "./images/founder/v.png"
import consulting from "./images/service/1.png"
import loan from "./images/service/2.png"
import nri from "./images/service/3.png"
import assistance from "./images/service/4.png"

export const Bannerdata = {
  mobilebanner: mobilebanner,
  screenbanner: screenbanner,
};

export const dataHeroSection = {
  type: "About",
  info: `Established in 2004, Property Station has become a trusted leader in real estate advisory, 
  offering comprehensive solutions for residential and commercial property purchase and investment. 
  Guided by our core values of commitment, honesty, and reliability, we’ve built a reputation for excellence
   in the industry. In just two decades, we’ve set benchmarks by helping clients make smart, informed decisions, 
   ensuring the best opportunities are identified to meet their needs. Our unwavering dedication to service has 
   made us one of India’s largest real estate advisories, consistently delivering value and building lasting 
   relationships with our clients. Your trust drives our success.`,
};

export const dataServiceSection = {
  type: "Services",
  title: `Our Services`,
  info: `Our commitment to excellence in residential real estate sets us apart as a
   trusted partner for all your housing needs. Whether you’re searching for a modern apartment, 
   a timeless villa, or an investment-worthy penthouse, our portfolio reflects the finest properties 
   in the market. Beyond just transactions, we offer tailored services that include advisory, market analysis,
    negotiation support, and post-purchase assistance to ensure your journey to finding the perfect residence is 
    smooth, secure, and satisfying.`,
};
export const dataVision = {
  type: "About",
  cards: [
    {
      title: `Our Vision`,
      message: `Transparency in transactions and uniformity in contracts define us.
       With expertise in real estate advisory, we…`,
    },
    {
      title: `Our Mission`,
      message: `We believe the journey to creating your dream home should be a seamless 
      and rewarding transformation. To achieve this, we…`,
    },
    {
      title: `Our Goal`,
      message: `Property Station is dedicated to helping our clients create value by 
      delivering personalized solutions for their real estate needs.`,
    },
  ],
};
export const dataServices = {
  type: "Services",
  cards: [
    {
      title: `Real Estate Consulting`,
      image:consulting,
      alt:"consulting",
      message: `The days of searching endlessly for your dream home are long gone.`,
    },
    {
      title: `Home Loan Consultation`,
      image:loan,
      alt:"loan",
      message: `Our impartial loan advisory, backed by partnerships with premier banks,
       simplifies your financial journey. `,
    },

    {
      title: `NRI Services`,
      image:nri,
      alt:"nri",
      message: `No longer on the sidelines, NRIs now make up over a significant
       percentage of stakeholders in the Indian housing sector.`,
    },
    {
      title: `After sales assistance`,
      image:assistance,
      alr:"assist",
      message: `We are committed to assisting our customers beyond the deal, 
      with post-purchase services and ongoing guidance.`,
    },
  ],
};
export const dataFounder = {
  type: "Founder",
  title: "Leadership ",
  cards: [
    {
      title: `fonder`,
      name: "Rohit Goyal",
      position: "Founder",
      image:Rohit_Goyal,
      alt:"RohitGoyal",
      message: `
      A highly motivated entrepreneur business man with an enthusiastic
       personality. He is the best example of working smartly with a hard approach. 
       
       The way he deals with each of his cux has made him earn a name that is known to all with respect. 
       He runs with a mission to help others reach the penultimate heights and make India great again. Those 
       who have worked and served him have always been admirers of the way he deals with all thicks and thins 
       with a cool temperament.`,
    },

    {
      title: `Managingpartner`,
      name: "Vishal Gupta",
      image:Vishal_Gupta,
      alt:"VishalGupta",
      position: "Managing Partner",
      message: `With over 25 years of diverse work experience, I bring a wealth of 
      expertise in real estate consulting, brokerage, and valuation services, coupled with robust 
      user acceptance testing skills. Previously serving as an Associate Director of Technology at Fidelity 
      Investments India, I spearheaded software solution development across multiple business domains. My proficiency
       spans management consulting, product management, and ensuring unparalleled customer satisfaction.`,
    },
    {
      title: `managingpartner`,
      name: "Shivali Gupta",
      image:Shivali_Gupta,
      alt:"ShivaliGupta",
      position: "Managing Partner",
      message: `With 15 years of banking expertise, joins Property Station as Managing Partner. 
      Her financial acumen and strategic leadership enhance our commitment to delivering premium real 
      estate solutions. Passionate about creating value-driven investments, Shivali ensures clients receive
       expert guidance, trust, and excellence in every step of their property journey. `,
    },
  ],
};
